import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { bbsOptimise, bbsAlgorithm,  bbsViewFiles,finalSummary } from './api';
import { message } from 'antd';

const initialState = {
  optimiseLoading: false,
  bbsAlgorithmLoading: false,
  bbsAlgorithmResult: [],
  bbsViewByIdData: [],
  bbsViewFilesLoading: false,
  finalSummaryData:{}
};

const actions = {
  BBS_OPTIMISE: 'BBS_OPTIMISE',
  BBS_ALGORITHM: 'BBS_ALGORITHM',
  BBS_VIEW_FILES: 'BBS_VIEW_FILES',
  FINAL_SUMMARY:'FINAL_SUMMARY'
};

export const createBbsOptimise = createAsyncThunk(
  actions.BBS_OPTIMISE,
  async (payload) => {
    const response = await bbsOptimise(payload);
    return response;
  },
);

export const createBBSAlgorithm = createAsyncThunk(
  actions.BBS_ALGORITHM,
  async (payload) => {
    const response = await bbsAlgorithm(payload);
    return response;
  },
);

export const getBBSViewFiles = createAsyncThunk(
  actions.BBS_VIEW_FILES,
  async (payload) => {
    console.log('payload', payload);
    const response = await bbsViewFiles(payload); // TODO: Check the API
    return response;
  },
);

export const getFinalBbsSummary = createAsyncThunk(
  actions.FINAL_SUMMARY,
  async (payload) => {
    const response = await finalSummary(payload);
    return response;
  },
);

export const bbsOptimiseSlice = createSlice({
  name: 'bbsOptimise',
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(createBbsOptimise.pending, (state) => {
        state.optimiseLoading = true;
      })
      .addCase(createBbsOptimise.fulfilled, (state, action) => {
        state.optimiseLoading = false;
      })
      .addCase(createBbsOptimise.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.optimiseLoading = false;
        message.error(msg);
      });

    builder
      .addCase(createBBSAlgorithm.pending, (state) => {
        state.bbsAlgorithmLoading = true;
      })
      .addCase(createBBSAlgorithm.fulfilled, (state, action) => {
        const { success, message: msg, results } = action.payload;
        state.bbsAlgorithmLoading = false;
        if (success && results?.length > 0) {
          message.success(msg);
          state.bbsAlgorithmResult = results;
        } else {
          message.error(msg);
        }
      })
      .addCase(createBBSAlgorithm.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.bbsAlgorithmLoading = false;
        message.error(msg);
      });

    builder
      .addCase(getBBSViewFiles.pending, (state) => {
        state.bbsViewFilesLoading = true;
      })
      .addCase(getBBSViewFiles.fulfilled, (state, action) => {
        state.loading = false;
        const { success, message: msg, results } = action.payload;
        state.bbsViewFilesLoading = false;
        if (success) {
          // message.success(msg);
          state.bbsViewByIdData = results?.length > 0 ? results : [];
        } else {
          message.error(msg);
        }
      })
      .addCase(getBBSViewFiles.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.bbsViewFilesLoading = false;
        message.error(msg);
      });
      builder
      .addCase(getFinalBbsSummary.pending, (state) => {
        state.loading = true;
      })
      .addCase(getFinalBbsSummary.fulfilled, (state, action) => {
        state.loading = false;
        state.finalSummaryData = action.payload;
      })
      .addCase(getFinalBbsSummary.rejected, (state, action) => {
        const { message: msg } = action.error;
        state.loading = false;
        message.error(msg);
      });
  },
});

export default bbsOptimiseSlice.reducer;
